import React, { useState } from "react";

const Settings = () => {
  const [formData, setFormData] = useState({
    name: "John Doe",
    email: "admin@example.com",
    password: "",
    confirmPassword: "",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (formData.password !== formData.confirmPassword) {
      alert("Passwords do not match!");
      return;
    }
    alert("Settings updated successfully!");
  };

  return (
    <div className="min-h-screen bg-gray-100 p-6 flex justify-start font-serif">
      <div className="w-full max-w-xl bg-white shadow-lg rounded-lg p-6 font-serif">
        <h1 className="text-2xl font-bold text-gray-800 mb-6 font-serif">
          Account Settings
        </h1>
        <form onSubmit={handleSubmit} className="space-y-4 font-serif">
          <div className="flex">
            <img
              src={
                "https://st.depositphotos.com/2218212/2938/i/450/depositphotos_29387653-stock-photo-facebook-profile.jpg"
              }
              alt="Profile Avatar"
              className="rounded-full border-2 border-[#730000] w-32 h-32 object-cover"
            />
          </div>
          {/* Name Field */}
          <div>
            <label
              htmlFor="name"
              className="block text-sm font-medium text-gray-700 mb-1 font-serif"
            >
              Name
            </label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="Enter your name"
              className="block font-serif w-full border border-gray-300 rounded-lg p-2.5 text-gray-700 focus:ring-blue-500 focus:border-blue-500"
            />
          </div>

          {/* Email Field */}
          <div>
            <label
              htmlFor="email"
              className="block text-sm font-medium text-gray-700 mb-1 font-serif"
            >
              Email
            </label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="Enter your email"
              className="block font-serif w-full border border-gray-300 rounded-lg p-2.5 text-gray-700 focus:ring-blue-500 focus:border-blue-500"
            />
          </div>

          {/* Password Field */}
          <div>
            <label
              htmlFor="password"
              className="block text-sm font-medium text-gray-700 mb-1 font-serif"
            >
              Password
            </label>
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              placeholder="Enter a new password"
              className="block font-serif w-full border border-gray-300 rounded-lg p-2.5 text-gray-700 focus:ring-blue-500 focus:border-blue-500"
            />
          </div>

          {/* Confirm Password Field */}
          <div>
            <label
              htmlFor="confirmPassword"
              className="block font-serif text-sm font-medium text-gray-700 mb-1"
            >
              Confirm Password
            </label>
            <input
              type="password"
              id="confirmPassword"
              name="confirmPassword"
              value={formData.confirmPassword}
              onChange={handleChange}
              placeholder="Confirm your password"
              className="block font-serif w-full border border-gray-300 rounded-lg p-2.5 text-gray-700 focus:ring-blue-500 focus:border-blue-500"
            />
          </div>

          {/* Submit Button */}
          <div className="pt-4">
            <button
              type="submit"
              className="w-full font-serif bg-[#730000] hover:bg-[#730000] text-white font-semibold py-2 px-4 rounded-lg shadow"
            >
              Update Settings
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Settings;
